import gsap from 'gsap';

let pageFadeOut = (event) => {
  event.preventDefault();

  let url = event.target.href;
  console.log(event.target)
  console.log(event.target.href)

  gsap.to('#mainPageContent', 0.3,  {
    opacity: 0,
    ease: 'power4.out',
  })
  gsap.to('#bgFadeIn' , 0.5, {
    opacity: 0,
    ease: 'power1.in',
  })
  gsap.to('.app-wrapper', 0.5, {
    opacity: 0,
    ease: 'power1.in',
    onComplete: () => {
      window.location = url;
    },
  })
}

export default pageFadeOut;



// WEBPACK FOOTER //
// ./scripts/components/pageFadeOut.js